import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import classes from './ResponsiveDialog.module.scss';

// Lightweight portal modal — replaces the old @material-ui/core Dialog so the
// app carries no Material-UI dependency. Same prop API the call sites already
// use: `open`, `onClose`, plus `walletModal`/`offerDetailsModal` to drop the
// "Terms & Conditions" title and/or the footer Close button.
export default function ResponsiveDialog(props) {
  const [open, setOpen] = React.useState(false);

  // Sync only when the controlled `open` prop actually changes. Depending on
  // the whole `props` object re-ran this on every parent render — e.g. each 1s
  // countdown tick — restarting the open animation (the expand/close flicker).
  useEffect(() => {
    if (props.open !== undefined) {
        setOpen(props.open)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.open])

  // Escape closes, matching the old Dialog.
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') props.onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  // Return keyboard focus to whatever opened the dialog once it closes.
  const triggerRef = React.useRef(null);
  useEffect(() => {
    if (open) {
      triggerRef.current = document.activeElement;
    } else if (triggerRef.current) {
      triggerRef.current.focus?.();
      triggerRef.current = null;
    }
  }, [open])

  if (!open) return null;

  const showTitle = !props.walletModal && !props.offerDetailsModal;
  const showActions = !props.offerDetailsModal;

  return ReactDOM.createPortal(
    <div
      className={classes.Scrim}
      role="dialog"
      aria-modal="true"
      aria-labelledby={showTitle ? 'responsive-dialog-title' : undefined}
      onClick={(e) => { if (e.target === e.currentTarget) props.onClose(); }}>
      <div className={classes.Paper}>
        {showTitle &&
          <h2 id="responsive-dialog-title" className={classes.Title}>Terms &amp; Conditions</h2>
        }
        <div className={classes.Content}>{props.children}</div>
        {showActions &&
          <div className={classes.Actions}>
            <button type="button" className={classes.CloseBtn} onClick={() => props.onClose()} autoFocus>
              Close
            </button>
          </div>
        }
      </div>
    </div>,
    document.body
  );
}
